module.exports = __webpack_public_path__ + "static/media/arrow-circle-empty-black.f4d1c0af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-circle-empty-black.svg
// module id = 366
// module chunks = 0